module.exports = __webpack_public_path__ + "static/media/crane4.b22b4fa0.png";